<div
    [class.full-length]="isFullLength"
    [class.light]="lightColor"
    [class.extra-light]="extraLightColor"
    class="{{ inclination }}">
</div>
